import { Ownership } from "./ownership";
import {ServiceLocation} from "./service-location";
import {TutorialBase} from "./tutorial-base";

export class Registration extends TutorialBase {
  public id: string;
  public name: string;
  public shortName: string;
  public key: string;
  public active = false;
  public locations: ServiceLocation[];
  public optionalJsonDeterminants: string;
  public mandatoryJsonDeterminants: string;
  public mandatoryChangeDisabled: boolean;
  public mandatorySelectedDefault: boolean = true;
  public sortOrder: number;
  public isInRenameMode: boolean;
  public isLoading: boolean;
  public ownership: Ownership;
  public selectedByDefault: boolean;
  public disabled: boolean;
  public businessKey: string;
}
